<template>
  <cf-validated-form
    name="editFavoriteOrder"
    @valid-submit="editFavoriteOrder(order.orderId)"
  >
    <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-y-16">
      <Teleport
        defer
        to="#portal-modal-header-target"
      >
        Favorite Order
      </Teleport>

      <p class="cf-subtitle cf-subtitle--2">
        Choose a nickname for your favorite order:
      </p>

      <cf-text-input
        v-model="favoriteOrderNickname"
        type="text"
        label="Nickname"
        name="favoriteOrderNickname"
        :validations="{
          required: true
        }"
      />

      <button
        class="cf-button cf-button--primary cf-button--lg cf-button--fill"
        :class="{ 'cf-button--loading': favoriteOrders.upsertingOrderId }"
        type="submit"
      >
        Save Order
      </button>
    </div>
  </cf-validated-form>
</template>


<script>
  import { mapGetters } from 'vuex';

  import errorHandlers from '@/services/error-handlers';

  import CfValidatedForm from '@/view/components/shared/cf-validated-form/index.vue';
  import CfTextInput from '@/view/components/shared/cf-text-input/index.vue';


  export default {
    name: 'EditFavoriteOrder',

    components: {
      CfValidatedForm,
      CfTextInput
    },

    props: {
      order: {
        type: Object,
        default: null
      },

      refresh: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        favoriteOrderNickname: ''
      };
    },

    computed: {
      ...mapGetters('favoriteOrders', ['favoriteOrders'])
    },

    created() {
      this.createdHandler();
    },

    methods: {
      createdHandler() {
        this.favoriteOrderNickname = this.order.nickname;
      },

      async editFavoriteOrder(orderId) {
        try {
          await this.$store.dispatch('favoriteOrders/upsertFavoriteOrder', {
            nickname: this.favoriteOrderNickname,
            orderId,
            refresh: this.refresh
          });

          // this.$triggerGoogleTrackingEvent('SaveFavoriteOrder', 'Favorites');

          this.$triggerNewRelicEvent('SaveFavoriteOrder', 'Information', 'Save Favorite Order');

          this.$closeModal('editFavoriteOrder');
          this.$emit('save');

          this.favoriteOrderNickname = null;
        }

        catch (error) {
          errorHandlers.generic(error);
        }
      }
    }
  };
</script>
